<div class="d-flex flex-column gap-3">

    <!-- contact -->
    <app-page-divider [text]="'know-how.contact.title' | transloco" [icon]="'fa-solid fa-address-book'">
    </app-page-divider>
    <app-know-how-contact-info></app-know-how-contact-info>

    <!-- documents -->
    <app-page-divider [text]="'know-how.documents.title' | transloco" [icon]="'fa-solid fa-file'">
    </app-page-divider>
    <app-know-how-documents-overview></app-know-how-documents-overview>
</div>
